import * as React from "react";
import * as shortid from "shortid";
import { IImageStatusType } from "../../../../share/types/adhoc";
import ImageDropZone from "src/share/components/ImageDropZone/ImageDropZone";

export interface ISearchImageDropZoneProps {
  setValue: (path: string, value: any) => void;
  imageSelected: boolean;
  imageName: string;
  imageUploadingStatus: IImageStatusType;
  searchInfo: any;
  loading: boolean;
  onClearSearch: () => void;
}

export class SearchImageDropZone extends React.Component<ISearchImageDropZoneProps, any> {
  constructor(props: ISearchImageDropZoneProps) {
    super(props);
  }

  public imageHandler(image: string = "image") {
    const { imageUploadingStatus, searchInfo, imageName, loading, setValue, onClearSearch } = this.props;
    const status = imageUploadingStatus && imageUploadingStatus[image] && imageUploadingStatus[image].status;

    return {
      onChange: (base64: string, name: string) => {
        setValue("searchInfo.searchId", shortid.generate());
        setValue("searchInfo.image.url", base64);
        setValue("imageSelected", true);
        setValue(`imageUploadingStatus[image]`, {});
        setValue("searchingMessage", "");
        setValue("imageName", name);
      },
      onClearSearch,
      loading,
      status,
      imageName,
      thumbnail: searchInfo.image.url || "",
      required: true,
      disabled: loading,
      labelText: `Image${imageName ? `: ${imageName}` : ''}`
    };
  }

  public render() {
    return (
      <div>
        <div className={`logo-agency-dropzone${!this.props.imageSelected ? " validationField" : ""}`}>
          <ImageDropZone {...this.imageHandler()} />
        </div>
      </div>
    );
  }
}

export default SearchImageDropZone;



// WEBPACK FOOTER //
// ./src/modules/AdHocTools/SearchByImage/components/SearchImageDropZone.tsx